import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MMProgressBarComponent } from './mm-progressbar.component';


@NgModule({
  declarations: [
    MMProgressBarComponent
  ],
  imports: [
    CommonModule
  ],
  providers: [
  ],
  exports: [
    MMProgressBarComponent
  ]
})
export class MMProgressBarModule { }